export const baseUrl = 'https://buddingtrends-node.herokuapp.com/';
//export const baseUrl = 'http://localhost:5000/';
export const measureID = 'G-C4TRG5TVFE';
export const tagManagerId = 'GTM-K684Z3R';
//const measureID = 'G-061MQB6MBM';
//export default { measureID, baseUrl };
//export const baseUrl = 'http://localhost:5000/';
